import React from 'react';
import { systemColor, systemLabel } from '../../helpers';

export default function SystemBadge({ systemId }) {
  if (!systemId) return null;
  const c = systemColor(systemId);
  return (
    <span className="badge mono" style={{
      background: `${c}18`,
      border:     `1px solid ${c}45`,
      color:      c,
      fontSize:   9,
    }}>
      {systemLabel(systemId)}
    </span>
  );
}
